import { render, staticRenderFns } from "./AdminApprovalStepForm.vue?vue&type=template&id=25bb2faf"
import script from "./AdminApprovalStepForm.vue?vue&type=script&lang=js"
export * from "./AdminApprovalStepForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports